import { cipo } from 'cipo';
import moment from 'moment';

cipo.directive("svgganttchart", function (GanttModel, $window, URI, userService, $http, Message) {
    return {
        restrict: "EA",
        scope: {
            "ganttdata": "="
        },
        templateUrl: "/ng/views/directives/system/svgganttchart.html",
        link: function ($scope, element) {
            $scope.container = $(element).find('#svgContainer');
            $scope.context = $scope.container[0];
            try {
                var gantt = new GanttModel($scope.container, $scope.ganttdata);
                gantt.drawGantt();
            } catch (e) {
                console.error(e);
            }
            
            /*
            var s = document.getElementById("svgContainerTIME");
            s.viewBox.baseVal.width = s.width.baseVal.value;
            s.viewBox.baseVal.height = s.height.baseVal.value;
            */


            
            $scope.mobileAndTabletcheck = function () {
                var check = false;
                (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
                return check;
            };

            //check for mobile & tablet to resize
            if ($scope.mobileAndTabletcheck()) {
                var tb = document.getElementById("tableID").style.width = "100px";
                var tml = document.getElementById("scrollTime").style.marginLeft = "100px";
                var gt = document.getElementById("scrollLine").style.marginLeft = "100px";
            }

            //var tb = document.getElementById("tableID").style.width = "150px";
            // var tml = document.getElementById("scrollTime").style.marginLeft = "150px";
            // var gt = document.getElementById("scrollLine").style.marginLeft = "150px";

            $scope.viewCount = 1;//0 is for default view
            //synced scroll bars
            var time = document.getElementById("scrollTime");
            var line = document.getElementById("scrollLine");

            var currentDateLine = document.getElementById("currentDateIDTimeline");
            currentDateLine.scrollIntoView(true);
            $(window).scrollTop(0);//scroll to top because svg is hidden from normal view

            time.onscroll = function () {
                line.scrollLeft = time.scrollLeft;
            }

            var dftBtnSwitch = function () {
                gantt.switchBetweenViews(gantt.lookup.currentViewID, "0");

                var timeCont = document.getElementById("svgContainerTIME");
                var lineCont = document.getElementById("svgContainerLINE");
                for (var i = 0; i < gantt.lookup.timelines.length; i++) {
                    if (gantt.lookup.timelines[i].view == "0") {
                        gantt.setSvgWidth(gantt.lookup.timelines[i].width, timeCont);
                        gantt.setSvgWidth(gantt.lookup.timelines[i].width, lineCont);
                    }
                }
            }

            var fBtn = document.createElement("md-button");

            var div = document.getElementById("wrapperSVGGANTT");
            var parent = document.getElementById("svgganttchartDirectiveId");
            parent.appendChild(fBtn);
            fBtn.innerHTML = "Add Filter";
            fBtn.className = "pull-left md-button md-ink-ripple";
            fBtn.title = "Add Filter";
            fBtn.style.marginTop = "7px";
            fBtn.style.zIndex = "1";
            fBtn.id = "addFilterID";

            fBtn.addEventListener("click", function () {
                var inputDiv = document.getElementById("filterInput");
                fBtn.innerHTML = "";
                
                inputDiv.style.display = "block";

            });

            var defaultViewBtn = document.createElement("md-button");
            parent.appendChild(defaultViewBtn);
            defaultViewBtn.innerHTML = "Default View";
            defaultViewBtn.className = "pull-left md-button md-ink-ripple";
            defaultViewBtn.title = "Default View";
            defaultViewBtn.style.marginTop = "7px";
            defaultViewBtn.style.zIndex = "1";

            defaultViewBtn.addEventListener("click", function () {
                dftBtnSwitch();
            });

            $scope.closeFilter = function () {
                var inputDiv = document.getElementById("filterInput");
                var st = document.getElementById("startDateID");
                var end = document.getElementById("endDateID");
                st.value = "";
                end.value = "";
                inputDiv.style.display = "none";
                var fBtn = document.getElementById("addFilterID");
                fBtn.innerHTML = "Add Filter";
                
            }

            $scope.deleteFilter = function (btn) {
                var viewID = btn.id.split(" ");
                var filter;
                for (var i = 0; i < gantt.filters.length; i++) {
                    if (gantt.filters[i].view == viewID) {
                        gantt.filters.splice(i, 1);
                        filter = gantt.filters[i]; 
                    }
                }

                var doc = document.getElementById("svgganttchartDirectiveId");
                doc.removeChild(btn);

                gantt.switchBetweenViews(gantt.lookup.currentViewID, "0");

                var timeCont = document.getElementById("svgContainerTIME");
                var lineCont = document.getElementById("svgContainerLINE");
                for (var i = 0; i < gantt.lookup.timelines.length; i++) {
                    if (gantt.lookup.timelines[i].view == "0") {
                        gantt.setSvgWidth(gantt.lookup.timelines[i].width, timeCont);
                        gantt.setSvgWidth(gantt.lookup.timelines[i].width, lineCont);
                    }
                }

                // console.log("to be deleted");//TO DO actually delete html elements
            }

            $scope.createFilter = function () {
                var inputDiv = document.getElementById("filterInput");
                var st = document.getElementById("startDateID");
                var end = document.getElementById("endDateID");
                var momentStart = moment(st.value).format("MM-DD-YYYY");
                var momentEnd = moment(end.value).format("MM-DD-YYYY");
                try {
                    gantt.addFilter(momentStart, momentEnd, "date", gantt.lookup.timelines[0], ($scope.viewCount).toString());
                    
                } catch (e) {
                    
                }  
                if (st.value != "" && end.value != "") {

                    var closeI = document.createElement("i");
                    closeI.className = "mdi mdi-close";
                    closeI.title = "Delete filter";
                    closeI.style.zIndex = "2";

                    

                    var newFilterBtn = document.createElement("md-button");
                    var startIHtml = moment(st.value).format("MM-DD-YYYY");
                    var endIHtml = moment(end.value).format("MM-DD-YYYY");
                    newFilterBtn.innerHTML = startIHtml + "/" + endIHtml;
                    newFilterBtn.className = "pull-left md-button md-ink-ripple";
                    newFilterBtn.title = "View " + ($scope.viewCount).toString();
                    newFilterBtn.style.marginTop = "7px";
                    newFilterBtn.style.zIndex = "1";
                    newFilterBtn.id = "ViewID " + ($scope.viewCount).toString();

                    st.value = "";
                    end.value = "";
                    inputDiv.style.display = "none";
                    var fBtn = document.getElementById("addFilterID");
                    fBtn.innerHTML = "Add Filter";

                    newFilterBtn.appendChild(closeI);
                    parent.appendChild(newFilterBtn);

                    newFilterBtn.addEventListener("click", function () {
                        var viewID = newFilterBtn.id.split(" ");

                        gantt.switchBetweenViews(gantt.lookup.currentViewID, (viewID[1]).toString());
                        var timeCont = document.getElementById("svgContainerTIME");
                        var lineCont = document.getElementById("svgContainerLINE");
                        for (var i = 0; i < gantt.lookup.timelines.length; i++) {
                            if (gantt.lookup.timelines[i].view == viewID[1]) {
                                gantt.setSvgWidth(gantt.lookup.timelines[i].width, timeCont);
                                gantt.setSvgWidth(gantt.lookup.timelines[i].width, lineCont);
                            }
                        }

                    });
                    $scope.viewCount++;

                    closeI.addEventListener("click", function (event) {
                        $scope.deleteFilter(newFilterBtn);
                        event.stopPropagation();
                    });


                }
                
            }

        }
    }
})
